// extracted by mini-css-extract-plugin
module.exports = {"buttons-container":"_2SYp7g8VPTChVxgjc3MWv7","hidden":"_17IJT6K-rNcbz8ljL8jDoy","toLeft":"hevSMPif8oUjgLkHj7djY","description":"_3xFUQBC2au1L92QwlnjUKW"};